// extracted by mini-css-extract-plugin
module.exports = {"opacityFadeIn":"MotionAnimations_opacityFadeIn__Os8tY","fade-in":"MotionAnimations_fade-in__ZWzHu"};